import { useEffect, Suspense } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useHomepage } from "./context/homepage/homepage.provider";
import styled from "styled-components/macro";
import smoothscroll from "smoothscroll-polyfill";
import { useAccount } from "./context/account/account.provider";
import { t } from "i18next";

import { setReferrer } from "./utils/navigation";
import useCheckTokenExpiration from "./utils/useCheckTokenExpiration";

// import rotatePhoneIcon from "./images/icons/mobile-rotate-rotation-icon.svg";
// import { useLayoutEffect } from "react";

// import Navbar                from "./components/Navbar/Navbar";
import HeaderNav                from "./components/Nav/HeaderNav";
import Footer                   from "./components/Footer";
import CookieConsentBanner      from "./components/Auth/CookieConsentBanner";
import FraudWarningModal        from "./components/FraudWarningModal";
import ToastComponent           from "./components/Toast/Toast";
import HoverCart                from "./components/Cart/HoverCart";
import ScrollHandler            from "./components/ScrollHandler";
import EmailConfirmationBanner  from "./components/EmailConfirmationBanner";
import TheRail                  from "./components/Restaurants/TheRail";

import AboutUs                from "./pages/AboutUs";
import Blog                   from "./pages/Blog";
import Careers                from "./pages/Careers";
import CareersFair            from "./pages/careers/CareersFair";
import Checkout               from "./pages/Checkout";
import Dining                 from "./pages/Dining";
import Egd                    from "./pages/Egd";
import EgdGameList            from "./pages/EgdGameList";
import ElectronicTableGames   from "./pages/ElectronicTableGames";
import Entertainment          from "./pages/Entertainment";
import HomePage               from "./pages/HomePage";
import Hotels                 from "./pages/Hotels";
import Legal                  from "./pages/Legal";
import MercierBridgeTraffic   from "./pages/MercierBridgeTraffic";
import MyAccount              from "./pages/MyAccount";
import AccountSettings        from "./pages/AccountSettings";
import PromoDrawsPage         from "./pages/PromoDrawsPage";
import AvailableEgdPromotions from "./pages/AvailableEgdPromotions";
import Page404                from "./pages/Page404";
import Promotions             from "./pages/Promotions";
import PromotionCardPreview   from "./pages/PromotionCardPreview";
import EntertainmentCardPreview from "./pages/EntertainmentCardPreview";
import EgdGameCardPreview from "./pages/EgdGameCardPreview";
import NavbarPreview from "./pages/NavbarPreview";
import PastEventWinnersPreview from "./pages/poker/PastEventWinnersPreview";
import HomeCarouselCardPreview from "./pages/HomeCarouselCardPreview";
import PokerCarouselSlidePreview from "./pages/PokerCarouselSlidePreview";
import EgdCarouselSlidePreview from "./pages/EgdCarouselSlidePreview";
import PlaygroundCares        from "./pages/PlaygroundCares";
import PlaygroundCaresDetails from "./pages/playgroundCares/PlaygroundCaresDetails";
import PlayersGuide           from "./pages/PlayersGuide";
import PrivacyPolicy          from "./pages/PrivacyPolicy";
import ResponsibleGaming      from "./pages/ResponsibleGaming";
import RespectfulEnvironment  from "./pages/RespectfulEnvironment";
import Rewards                from "./pages/Rewards";
import SmsTermsConditions     from "./pages/SmsTermsConditions";
import VisitUs                from "./pages/VisitUs";
import Unsubscribed           from "./pages/Unsubscribed";
import Subscription           from "./pages/Subscription";

import ForgotPassword     from "./pages/auth/ForgotPassword";
import Login              from "./pages/auth/Login";
import Register           from "./pages/auth/Register";
import ResetPassword      from "./pages/auth/ResetPassword";
import SignUpExistingUser from "./pages/auth/SignUpExistingUser";

import BbjHits                from "./pages/blog/BbjHits";
import KahnawakePowWow        from "./pages/blog/KahnawakePowWow";
import AugustMillionFestival  from "./pages/blog/AugustMillionFestival";
import DiscoverReasonsWsop    from "./pages/blog/DiscoverReasonsWsop";

import MusicalMonday            from "./pages/entertainment/MusicalMonday";
import GirlsNightOut            from "./pages/entertainment/GirlsNightOut";
import GameDay2024              from "./pages/entertainment/GameDay2024";
import HockeyNightAtTheRail2024 from "./pages/entertainment/HockeyNightAtTheRail2024";
import Halloween2024            from "./pages/entertainment/Halloween2024";
import NewYearsEve2025          from "./pages/entertainment/NewYearsEve2025";
import NewYearsEve2026          from "./pages/entertainment/NewYearsEve2026";
import Valentines2025           from "./pages/entertainment/Valentines2025";
import Valentines2026           from "./pages/entertainment/Valentines2026";
import BigGameBash2025          from "./pages/entertainment/BigGameBash2025";
import BigGameBash2026          from "./pages/entertainment/BigGameBash2026";
import FightQuest61             from "./pages/entertainment/FightQuest61";

import PeaceLoveAndMoney        from "./pages/promotions/egd/PeaceLoveAndMoney";
import WelcomeBackBonus         from "./pages/promotions/egd/WelcomeBackBonus";
import HappyBirthday            from "./pages/promotions/egd/HappyBirthday";
import FollowForFreePlay        from "./pages/promotions/egd/FollowForFreePlay";
import OptInAndWin              from "./pages/promotions/egd/OptInAndWin";
import BoomingWednesday         from "./pages/promotions/egd/BoomingWednesday";
import FreePlayFriday           from "./pages/promotions/egd/FreePlayFriday";
import HollywoodNights          from "./pages/promotions/egd/HollywoodNights";
import JackpotParties           from "./pages/promotions/egd/JackpotParties";
import WalkOfFame2023           from "./pages/promotions/egd/WalkOfFame2023";
import SnackAndSpin             from "./pages/promotions/egd/SnackAndSpin";
import GongXiFaCai              from "./pages/promotions/egd/GongXiFaCai";
import JackpotParties2024       from "./pages/promotions/egd/JackpotParties2024";
import HotSeatThursday2023      from "./pages/promotions/egd/HotSeatThursday2023";
import BigGameBash2024          from "./pages/promotions/egd/BigGameBash2024";
import LeapAndLoot2024          from "./pages/promotions/egd/LeapAndLoot2024";
import InstaWin2024             from "./pages/promotions/egd/InstaWin2024";
import FeteJackpotHebdomadaire  from "./pages/promotions/egd/FeteJackpotHebdomadaire";
import BonVoyage2024            from "./pages/promotions/egd/BonVoyage2024";
import ChaseTheAce2024          from "./pages/promotions/egd/ChaseTheAce2024";
import ChineseNewYear2025       from "./pages/promotions/egd/ChineseNewYear2025";
import ChineseNewYear2025Games  from "./pages/promotions/egd/ChineseNewYear2025Games";
import ChineseNewYear2025Promo  from "./pages/promotions/egd/ChineseNewYear2025Promo";
import ChineseNewYear2026       from "./pages/promotions/egd/ChineseNewYear2026";
import ChineseNewYear2026Games  from "./pages/promotions/egd/ChineseNewYear2026Games";
import ThursdayGiftInventory    from "./pages/promotions/egd/ThursdayGiftInventory";
import ThursdayGiftInventoryTV  from "./pages/promotions/egd/ThursdayGiftInventoryTV";
import SaintPatricksDay2025     from "./pages/promotions/egd/SaintPatricksDay2025";
import SaintPatricksDay2026     from "./pages/promotions/egd/SaintPatricksDay2026";
import EasterEggStravaganza2026 from "./pages/promotions/egd/EasterEggStravaganza2026";
import SpinAndSpoilMom2025      from "./pages/promotions/egd/SpillAndSpoilMom2025";
import SpinAndSpoilMom2026      from "./pages/promotions/egd/SpinAndSpoilMom2026";
import DownloadAndWin2026       from "./pages/promotions/DownloadAndWin2026";
import CashnadoSpring2026        from "./pages/promotions/egd/CashnadoSpring2026";
import Cashnado2026              from "./pages/promotions/egd/Cashnado2026";
import NclCruiseMarch2026       from "./pages/promotions/egd/NclCruiseMarch2026";
import MscCruiseApril2026       from "./pages/promotions/egd/MscCruiseApril2026";
import RcgCruiseJuly2026        from "./pages/promotions/egd/RcgCruiseJuly2026";
import RcgCruiseJuly2026Rsvp    from "./pages/promotions/egd/RcgCruiseJuly2026Rsvp";
import EasterEggStravaganza2025 from "./pages/promotions/egd/EasterEggStravaganza2025";
import NuitElite                from "./pages/promotions/egd/NuitElite";
import BirthdayBash2025         from "./pages/promotions/egd/BirthdayBash2025";
import UltimateDad2025          from "./pages/promotions/egd/UltimateDad2025";
import UltimateDad2026          from "./pages/promotions/egd/UltimateDad2026";
import GPFreePlay2025           from "./pages/promotions/egd/GPFreePlay2025";
import GPFreePlay2026           from "./pages/promotions/egd/GPFreePlay2026";
import MultiplierFridays2025    from "./pages/promotions/egd/MultiplierFridays2025";
import HauntedCarnival2025     from "./pages/promotions/egd/HauntedCarnival2025";
import LadiesNight2025          from "./pages/promotions/egd/LadiesNight2025";
import DragonAfterHours2025     from "./pages/restaurants/DragonAfterHours2025";
import DragonDiceNights        from "./pages/restaurants/DragonDiceNights";
import JackpotParty             from "./pages/promotions/egd/JackpotParty";
import WinningWednesday         from "./pages/promotions/egd/WinningWednesday";
import ClubElite2025            from "./pages/promotions/egd/ClubElite2025";
import WinAMillion2025          from "./pages/promotions/egd/WinAMillion2025";
import WinAMillionTV            from "./pages/WinAMillionTV";
import FreePlayPrizesMarch2026TV from "./pages/FreePlayPrizesMarch2026TV";
import SuperBowlTV2026          from "./pages/SuperBowlTV2026";
import CashnadoSpring2026TV     from "./pages/CashnadoSpring2026TV";
import Cashnado2026TV           from "./pages/Cashnado2026TV";
import CashnadoAugust2026TV     from "./pages/CashnadoAugust2026TV";
import ScavengerHunt2025        from "./pages/promotions/egd/ScavengerHunt2025";
import ScavengerHuntDynamic2025 from "./pages/promotions/egd/ScavengerHuntDynamic2025";
import PodcastFreePlayDynamic2026 from "./pages/promotions/egd/PodcastFreePlayDynamic2026";
import OpenFortuneFreePlay2026   from "./pages/promotions/egd/OpenFortuneFreePlay2026";
import TierMatch2026            from "./pages/promotions/TierMatch2026";

import BadBeatJackpots                from "./pages/promotions/poker/BadBeatJackpots";
import BadBeatJackpotRules            from "./pages/promotions/poker/BadBeatJackpotRules";
import HighHands                      from "./pages/promotions/poker/HighHands";
import TournamentLeaderboard          from "./pages/promotions/poker/TournamentLeaderboard";
import MonterCarlo2024                from "./pages/promotions/poker/MonterCarlo2024";
import IrishOpen2024                  from "./pages/promotions/poker/IrishOpen2024";
import IrishOpen2025                  from "./pages/promotions/poker/IrishOpen2025";
import MysteryHighHand                from "./pages/promotions/poker/MysteryHighHand";
import MegaMysteryHighHand            from "./pages/promotions/poker/MegaMysteryHighHand";
import MysteryHighHandOctober2024     from "./pages/promotions/poker/MysteryHighHandOctober2024";
import MysteryHighHandNovember2024    from "./pages/promotions/poker/MysteryHighHandNovember2024";
import HighHandJanuary2025            from "./pages/promotions/poker/HighHandJanuary2025";
import PokerNewYearsEve2025           from "./pages/promotions/poker/PokerNewYearsEve2025";
import TitanTuesday2025               from "./pages/promotions/poker/TitanTuesday2025";
import TitanTuesday2026               from "./pages/promotions/poker/TitanTuesday2026";
import TitanTuesdayMarch2026          from "./pages/promotions/poker/TitanTuesdayMarch2026";
import TitanTuesdayMay2026            from "./pages/promotions/poker/TitanTuesdayMay2026";
import HockeyNightAtPlayground2025   from "./pages/promotions/poker/HockeyNightAtPlayground2025";
import HockeyNightPlaygroundPlayoffs2026 from "./pages/promotions/poker/HockeyNightPlaygroundPlayoffs2026";
import HighHandFebruary2025           from "./pages/promotions/poker/HighHandFebruary2025";
import HighHandMarch2025              from "./pages/promotions/poker/HighHandMarch2025";
import HighHandMain                   from "./pages/promotions/poker/highHand/HighHandMain";
import MainEventMaynia2025            from "./pages/promotions/poker/MainEventMaynia2025";
import MultiMillionaireMaker2025      from "./pages/promotions/poker/MultiMillionaireMaker2025";
import MultiMillionaireMakerAugust2025 from "./pages/promotions/poker/MultiMillionaireMakerAugust2025";
import MultiMillionaireMakerSeptember2025 from "./pages/promotions/poker/MultiMillionaireMakerSeptember2025";
import TripleBarrelCashBlast2025 from "./pages/promotions/poker/TripleBarrelCashBlast2025";
import TripleBarrelCashBlast2025AnniversaryEdition from "./pages/promotions/poker/TripleBarrelCashBlast2025AnniversaryEdition";
import TripleBarrelCashBlast2026 from "./pages/promotions/poker/TripleBarrelCashBlast2026";
import TripleBarrelCashBlastFebruary2026 from "./pages/promotions/poker/TripleBarrelCashBlastFebruary2026";
import TripleBarrelCashBlastMarch2026 from "./pages/promotions/poker/TripleBarrelCashBlastMarch2026";
import LuxonPayGiveaway2026 from "./pages/promotions/poker/LuxonPayGiveaway2026";
import WsopcPlaygroundMay2026CreatorChampionship from "./pages/promotions/poker/WsopcPlaygroundMay2026CreatorChampionship";

import ClassicAmericanBreakfast from "./pages/promotions/dining/ClassicAmericanBreakfast";
import PlaygroundBuffets        from "./pages/promotions/dining/PlaygroundBuffets";
import SweetSaturdays           from "./pages/promotions/dining/SweetSaturdays";
import SurfAndTurf2024          from "./pages/promotions/dining/SurfAndTurf2024";
import LobsterSpecial2025       from "./pages/promotions/dining/LobsterSpecial2025";
import LunchSpecial             from "./pages/promotions/dining/LunchSpecial";
import FreeBurgerPromo2025      from "./pages/promotions/dining/FreeBurgerPromo2025";
import SurfAndTurf2025          from "./pages/promotions/dining/SurfAndTurf2025";
import SteakFriesSpecial2025    from "./pages/promotions/dining/SteakFriesSpecial2025";
import AllYouCanEat2025         from "./pages/promotions/dining/AllYouCanEat2025";
import Wine50OffEtc2025         from "./pages/promotions/dining/Wine50OffEtc2025";
import EtcSteakFritesSpecial2026 from "./pages/promotions/dining/EtcSteakFritesSpecial2026";
import FiletMignonSpecial2025   from "./pages/promotions/dining/FiletMignonSpecial2025";
import FreePlayLunch2025            from "./pages/promotions/dining/FreePlayLunch2025";
import FreeRotisserieChicken2025 from "./pages/promotions/dining/FreeRotisserieChicken2025";
import FreeChickenParmesan2026 from "./pages/promotions/dining/FreeChickenParmesan2026";
import DynamicDiningPromo from "./pages/promotions/dining/DynamicDiningPromo";

import Poker                    from "./pages/Poker";
import Calendar                 from "./pages/poker/Calendar";
import CashGames                from "./pages/poker/CashGames";
import PastEvents               from "./pages/poker/PastEvents";
import PastEventWinners         from "./pages/poker/PastEventWinners";
import TournamentList           from "./pages/poker/TournamentList"; // Temp Listing Page
import IndividualTournament     from "./pages/poker/IndividualTournament";
import EatAndPlay               from "./pages/poker/EatAndPlay";
import BadBeatJackpotsTv        from "./pages/poker/BadBeatJackpotsTv";
import HighStakesBBJTv          from "./pages/poker/HighStakesBBJTv";
import PokerPlayer              from "./pages/poker/PokerPlayer";
import PokerTableFilmingPolicy  from "./pages/poker/PokerTableFilmingPolicy";


import SuccessfulPayment  from "./pages/confirmation/SuccessfulPayment";
import RequestPassword    from "./pages/confirmation/RequestPassword";
import ExistingUser       from "./pages/confirmation/ExistingUser";
import NewUser            from "./pages/confirmation/NewUser";
import EmailConfirmation  from "./pages/confirmation/EmailConfirmation";


import WorldCupOfCards2021  from "./pages/poker/tournaments/WorldCupOfCards2021/WorldCupOfCards2021";
import TournamentDetails    from "./pages/poker/tournaments/TournamentDetails";
import HowToRedeem          from "./components/Rewards/HowToRedeem";
import TokenExpiryModal     from "./components/TokenExpiryModal";
import WsopcPlaygroundSpring2025ColossusGiveaway from "./pages/promotions/poker/WsopcPlaygroundSpring2025ColossusGiveaway";
import RoomsForRent         from "./pages/RoomsForRent";
import RoomsForRentForm     from "./pages/RoomsForRentForm";
import { isAppWebView } from "./utils/isAppWebView";




// import ElectronicGamingDevices from "./pages/ElectronicGamingDevices";

const PrivateRoute = ({ children, access_token }) => {
  return access_token ? (
    children
  ) : (
    <Navigate to={t("routes.login")} replace />
  );
};

function App() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const { menuBarToggle } = useHomepage();
  const { access_token, tokenExpiry } = useAccount();
  useCheckTokenExpiration();

  // smoothscroll.polyfill();
  //let me know if we actually need this :))
  window.__forceSmoothScrollPolyfill__ = true;


  useEffect(() => {
    setReferrer(location.pathname, t);
  }, [location.pathname]);

  // const goToTop = () => {
  //   window.scroll({ top: 0, left: 0, behavior: "smooth" });
  // };

  // useLayoutEffect(() => {
  //   goToTop();
  // }, []);

  const tvPaths = [
    "/poker/bad-beat-jackpot-tv",
    "/poker/high-stakes-bad-beat-jackpot-tv",
    "/promotions/gaming-machines/gift-inventory-tv",
    "/win-a-million-tv",
    "/free-play-prizes-march-2026-tv",
    "/super-bowl-tv-2026",
    "/cashnado-spring-2026-tv",
    "/cashnado-2026-tv",
    "/cashnado-august-2026-tv"
  ];

  // Pages where modals (cookie banner and fraud modal) should be hidden
  const modalExcludedPaths = [
    ...tvPaths,
    t("routes.subscription")
  ];

  const promotionPreviewPaths = [
    "/promotions/preview",
    "/fr/promotions/preview",
  ];

  const entertainmentPreviewPaths = [
    "/entertainment/preview",
    "/fr/entertainment/preview",
  ];

  const egdGamePreviewPaths = [
    "/gaming-machines/egd-games/preview",
    "/fr/gaming-machines/egd-games/preview",
  ];

  const navbarPreviewPaths = [
    "/navbar/preview",
    "/fr/navbar/preview",
  ];

  const pastEventWinnersPreviewPaths = [
    "/poker/past-events/preview",
    "/fr/poker/past-events/preview",
  ];
  const homeCarouselPreviewPaths = [
    "/home/preview",
    "/fr/home/preview",
  ];

  const pokerCarouselPreviewPaths = [
    "/poker/preview",
    "/fr/poker/preview",
  ];

  const egdCarouselPreviewPaths = [
    "/gaming-machines/preview",
    "/fr/gaming-machines/preview",
  ];

  // On navbar preview the header lives inside the route tree (not a direct `.navbar`
  // child of MainDiv), so the page blur would smear the menu itself — skip it.
  const blurBackground =
    menuBarToggle && !navbarPreviewPaths.includes(location.pathname);

  const livePreviewPaths = [
    ...promotionPreviewPaths,
    ...entertainmentPreviewPaths,
    ...egdGamePreviewPaths,
    ...navbarPreviewPaths,
    ...pastEventWinnersPreviewPaths,
    ...homeCarouselPreviewPaths,
    ...pokerCarouselPreviewPaths,
    ...egdCarouselPreviewPaths,
  ];

  // Detect if running inside the app's webview
  const isAppWebViewFlag = isAppWebView();

  // Combined condition for showing modals
  const shouldShowModals =
    !modalExcludedPaths.includes(location.pathname) &&
    !livePreviewPaths.includes(location.pathname) &&
    !isAppWebViewFlag;

  const headerFooterExcludedPaths = [
    ...tvPaths,
    ...livePreviewPaths,
    t("routes.register"),
    t("routes.login"),
    t("routes.forgotPassword"),
    t("routes.resetPassword"),
    t("routes.signUpExistingUser"),
  ];

  const hoverCartExcludedPaths = [
    ...headerFooterExcludedPaths,
    t("routes.checkout")
  ];

  const renderPrivateRoute = (element) => (
    <PrivateRoute access_token={access_token}>{element}</PrivateRoute>
  );
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback="loading">
        <MainDiv blur={blurBackground} className="root">
          <ToastComponent />
          {shouldShowModals && <CookieConsentBanner />}
          {shouldShowModals && <FraudWarningModal />}
          {tokenExpiry && <TokenExpiryModal />}
          {!hoverCartExcludedPaths.includes(location.pathname) && <HoverCart />}
          {!headerFooterExcludedPaths.includes(location.pathname) && !isAppWebViewFlag && <HeaderNav />}
          {access_token && <EmailConfirmationBanner />}
          <ScrollHandler />
          <Routes>
            <Route
              path={t("routes.homepage")}
              element={<HomePage />}
            />
            <Route
              path="/logout"
              element={<Navigate replace to={t("routes.homepage")} />}
            />
            <Route
              path={t("routes.pokerTournamentCalendar")}
              element={<Calendar />}
            />
            <Route
              path={t("routes.dining")}
              element={<Dining />}
            />
            <Route
              path={t("routes.allYouCanEat2025")}
              element={<AllYouCanEat2025 />}
            />
            <Route
              path={t("routes.promotionsPreview")}
              element={<PromotionCardPreview />}
            />
            <Route
              path={t("routes.entertainmentPreview")}
              element={<EntertainmentCardPreview />}
            />
            <Route
              path="/gaming-machines/egd-games/preview"
              element={<EgdGameCardPreview />}
            />
            <Route
              path="/fr/gaming-machines/egd-games/preview"
              element={<EgdGameCardPreview />}
            />
            <Route
              path="/navbar/preview"
              element={<NavbarPreview />}
            />
            <Route
              path="/fr/navbar/preview"
              element={<NavbarPreview />}
            />
            <Route
              path={t("routes.pastEventWinnersPreview")}
              element={<PastEventWinnersPreview />}
            />
            <Route
              path="/home/preview"
              element={<HomeCarouselCardPreview />}
            />
            <Route
              path="/fr/home/preview"
              element={<HomeCarouselCardPreview />}
            />
            <Route
              path="/poker/preview"
              element={<PokerCarouselSlidePreview />}
            />
            <Route
              path="/fr/poker/preview"
              element={<PokerCarouselSlidePreview />}
            />
            <Route
              path="/gaming-machines/preview"
              element={<EgdCarouselSlidePreview />}
            />
            <Route
              path="/fr/gaming-machines/preview"
              element={<EgdCarouselSlidePreview />}
            />
            <Route path={t("routes.promotions")} element={<Promotions />} />
            <Route
              path={t("routes.promotionsCategory")}
              element={<Promotions />}
            />
            <Route
              path={t("routes.entertainment")}
              element={<Entertainment />}
            />
            <Route
              path={t("routes.entertainmentCategory")}
              element={<Entertainment />}
            />
            <Route path={t("routes.aboutUs")} element={<AboutUs />} />
            <Route path={t("routes.rewards")} element={<Rewards />} />
            <Route path={t("routes.rewardsTab")} element={<Rewards />} />
            <Route path={t("routes.howToRedeem")} element={<Rewards />}>
              <Route path=":tabId" element={<HowToRedeem />} />
            </Route>
            {/* if access token missing redirect those pages to homepage */}
            <Route
              path={t("routes.myAccount")}
              element={renderPrivateRoute(<MyAccount />)}
            />
            <Route
              path={t("routes.accountSettings")}
              element={renderPrivateRoute(<AccountSettings />)}
            />
            <Route
              path={t("routes.accountDraws")}
              element={renderPrivateRoute(<PromoDrawsPage />)}
            />
            <Route
              path={t("routes.accountAvailablePromos")}
              element={renderPrivateRoute(<AvailableEgdPromotions />)}
            />

            <Route
              path={t("routes.checkout")}
              element={renderPrivateRoute(<Checkout />)}
            />
            {/* ---------------------------------------------------------- */}
            <Route
              path={t("routes.playgroundCares")}
              element={<PlaygroundCares />}
            />
            <Route
              path={t("routes.privacyPolicy")}
              element={<PrivacyPolicy />}
            />
            <Route
              path={t("routes.smsTermsConditions")}
              element={<SmsTermsConditions />}
            />
            <Route path={t("routes.legal")} element={<Legal />} />
            <Route
              path={t("routes.responsibleGaming")}
              element={<ResponsibleGaming />}
            />
            <Route
              path={t("routes.respectfulEnvironment")}
              element={<RespectfulEnvironment />}
            />
            <Route path={t("routes.careers")} element={<Careers />} />
            <Route path={t("routes.careersFair")} element={<CareersFair />} />
            <Route path={t("routes.visitUs")} element={<VisitUs />} />
            <Route path={t("routes.hotels")} element={<Hotels />} />
            <Route
              path={t("routes.mercierBridgeTraffic")}
              element={<MercierBridgeTraffic />}
            />
            <Route
              path={t("routes.playgroundCaresDetails")}
              element={<PlaygroundCaresDetails />}
            />
            <Route path={t("routes.electronicTableGames")} element={<ElectronicTableGames />} />
            <Route path={t("routes.electronicTableGameTabs")} element={<ElectronicTableGames />} />
            <Route path={t("routes.playersGuide")} element={<PlayersGuide />} />
            {/* <Route path="/egd" element={<ElectronicGamingDevices />} /> */}
            <Route path={t("routes.register")} element={<Register />} />
            <Route path={t("routes.login")} element={<Login />} />
            {/* egd */}
            <Route path={t("routes.egd")} element={<Egd />} />
            {/* <Route path={t("routes.egdTab")} element={<Egd />} /> */}
            <Route path={t("routes.egdGameList")} element={<EgdGameList />} />
            <Route path={t("routes.egdGameListTab")} element={<EgdGameList />} />
            <Route path={t("routes.snackSpin")} element={<SnackAndSpin />} />
            <Route
              path={t("routes.peaceLoveMoney")}
              element={<PeaceLoveAndMoney />}
            />
            <Route
              path={t("routes.welcomeBackBonus")}
              element={<WelcomeBackBonus />}
            />
            <Route
              path={t("routes.happyBirthday")}
              element={<HappyBirthday />}
            />
            <Route
              path={t("routes.followForFreePlay")}
              element={<FollowForFreePlay />}
            />
            <Route path={t("routes.optInAnWin")} element={<OptInAndWin />} />
            <Route
              path={t("routes.boomingWednesday")}
              element={<BoomingWednesday />}
            />
            <Route
              path={t("routes.sweetSaturdays")}
              element={<SweetSaturdays />}
            />
            <Route
              path={t("routes.surfAndTurf2024")}
              element={<SurfAndTurf2024 />}
            />
            <Route
              path={t("routes.lobsterSpecial2025")}
              element={<LobsterSpecial2025 />}
            />
            <Route
              path={t("routes.lunchSpecial")}
              element={<LunchSpecial />}
            />
            <Route
              path={t("routes.freePlayLunch2025")}
              element={<FreePlayLunch2025 />}
            />
            <Route
              path={t("routes.classicAmericanBreakfast")}
              element={<ClassicAmericanBreakfast />}
            />
            <Route
              path={t("routes.playgroundBuffets")}
              element={<PlaygroundBuffets />}
            />
            <Route
              path={t("routes.freeBurgerPromo2025")}
              element={<FreeBurgerPromo2025 />}
            />
            <Route
              path={t("routes.surfAndTurf2025")}
              element={<SurfAndTurf2025 />}
            />
            <Route
              path={t("routes.steakFriesSpecial2025")}
              element={<SteakFriesSpecial2025 />}
            />
            <Route
              path={t("routes.freeRotisserieChicken2025")}
              element={<FreeRotisserieChicken2025 />}
            />
            <Route
              path={t("routes.freeChickenParmesan2026")}
              element={<FreeChickenParmesan2026 />}
            />
            <Route
              path={t("routes.freeFishAndChips2026")}
              element={<DynamicDiningPromo promoKey="freeFishAndChips2026" scheduleKeyName="freeFishAndChips2026" />}
            />
            <Route
              path={t("routes.freeBbqBrisket2026")}
              element={<DynamicDiningPromo promoKey="freeBbqBrisket2026" scheduleKeyName="freeBbqBrisket2026" />}
            />
            <Route
              path={t("routes.freeLobsterAndShrimpRoll2026")}
              element={<DynamicDiningPromo promoKey="freeLobsterAndShrimpRoll2026" scheduleKeyName="freeLobsterAndShrimpRoll2026" />}
            />
            <Route
              path={t("routes.freeBbqRibs2026")}
              element={<DynamicDiningPromo promoKey="freeBbqRibs2026" scheduleKeyName="freeBbqRibs2026" />}
            />
            <Route
              path={t("routes.wine50OffEtc2025")}
              element={<Wine50OffEtc2025 />}
            />
            <Route
              path={t("routes.etcSteakFritesSpecial2026")}
              element={<EtcSteakFritesSpecial2026 />}
            />
            <Route
              path={t("routes.cocktailsDrinks50Off2026")}
              element={<DynamicDiningPromo promoKey="cocktailsDrinks50Off2026" scheduleKeyName="cocktailsDrinks50Off2026" />}
            />
            <Route
              path={t("routes.filetMignonSpecial2025")}
              element={<FiletMignonSpecial2025 />}
            />
            <Route
              path={t("routes.freePlayFriday")}
              element={<FreePlayFriday />}
            />
            <Route
              path={t("routes.fiveOr7_2025")}
              element={<DynamicDiningPromo promoKey="fiveOr7_2025" scheduleKeyName="fiveOr7_2025" />}
            />
            <Route
              path={t("routes.hollywoodNights2023")}
              element={<HollywoodNights />}
            />
            <Route
              path={t("routes.jackpotPartyMay2023")}
              element={<JackpotParties />}
            />
            <Route
              path={t("routes.jackpotPartyFebruary2024")}
              element={<JackpotParties2024 />}
            />
            <Route
              path={t("routes.walkOfFame2023")}
              element={<WalkOfFame2023 />}
            />
            <Route
              path={t("routes.hotSeatThursday2023")}
              element={<HotSeatThursday2023 />}
            />
            <Route
              path={t("routes.gongXiFaCai2024")}
              element={<GongXiFaCai />}
            />
            <Route
              path={t("routes.bigGameBash2024")}
              element={<BigGameBash2024 />}
            />
            <Route
              path={t("routes.leapAndLoop2024")}
              element={<LeapAndLoot2024 />}
            />
            <Route path={t("routes.instawin")} element={<InstaWin2024 />} />
            <Route
              path={t("routes.weeklyJackpotParty")}
              element={<JackpotParty />}
            />
            <Route
              path={t("routes.jackpotParty")}
              element={<JackpotParty />}
            />
            <Route
              path={t("routes.bonVoyage2024")}
              element={<BonVoyage2024 />}
            />
            <Route
              path={t("routes.chaseTheAce2024")}
              element={<ChaseTheAce2024 />}
            />
            <Route
              path={t("routes.chineseNewYear2025")}
              element={<ChineseNewYear2025 />}
            />
            <Route
              path={t("routes.chineseNewYear2025Games")}
              element={<ChineseNewYear2025Games />}
            />
            <Route
              path={t("routes.chineseNewYear2025Promo")}
              element={<ChineseNewYear2025Promo />}
            />
            <Route
              path={t("routes.chineseNewYear2026")}
              element={<ChineseNewYear2026 />}
            />
            <Route
              path={t("routes.chineseNewYear2026Games")}
              element={<ChineseNewYear2026Games />}
            />
            <Route
              path="/promotions/gaming-machines/gift-inventory"
              element={<ThursdayGiftInventory />}
            />
            <Route
              path="/promotions/gaming-machines/gift-inventory-tv"
              element={<ThursdayGiftInventoryTV />}
            />
            <Route
              path={t("routes.saintPatricksDay2025")}
              element={<SaintPatricksDay2025 />}
            />
            <Route
              path={t("routes.saintPatricksDay2026")}
              element={<SaintPatricksDay2026 />}
            />
            <Route
              path={t("routes.easterEggStravaganza2026")}
              element={<EasterEggStravaganza2026 />}
            />
            <Route
              path={t("routes.easterEggStravaganza2025")}
              element={<EasterEggStravaganza2025 />}
            />
            <Route
              path={t("routes.spinAndSpoilMom2025")}
              element={<SpinAndSpoilMom2025 />}
            />
            <Route
              path={t("routes.spinAndSpoilMom2026")}
              element={<SpinAndSpoilMom2026 />}
            />
            <Route
              path={t("routes.downloadAndWin2026")}
              element={<DownloadAndWin2026 />}
            />
            <Route
              path={t("routes.downloadAndWin")}
              element={<DownloadAndWin2026 />}
            />
            <Route
              path={t("routes.cashnadoSpring2026")}
              element={<CashnadoSpring2026 />}
            />
            <Route
              path={t("routes.cashnadoSpring2026Short")}
              element={<CashnadoSpring2026 />}
            />
            <Route
              path={t("routes.cashnado2026")}
              element={<Cashnado2026 />}
            />
            <Route
              path={t("routes.nclCruiseMarch2026")}
              element={<NclCruiseMarch2026 />}
            />
            <Route
              path={t("routes.mscCruiseApril2026")}
              element={<MscCruiseApril2026 />}
            />
            <Route
              path={t("routes.rcgCruiseJuly2026")}
              element={<RcgCruiseJuly2026 />}
            />
            <Route
              path={t("routes.rcgCruiseJuly2026Rsvp")}
              element={<RcgCruiseJuly2026Rsvp />}
            />
            {/* poker */}
            <Route
              path={t("routes.pokerTableFilmingPolicy")}
              element={<PokerTableFilmingPolicy />}
            />
            <Route
              path={t("routes.badBeatJackpot")}
              element={<BadBeatJackpots />}
            />
            <Route
              path="/poker/bad-beat-jackpot-tv"
              element={<BadBeatJackpotsTv />}
            />
            <Route
              path="/poker/high-stakes-bad-beat-jackpot-tv"
              element={<HighStakesBBJTv />}
            />
            <Route
              path={t("routes.badBeatJackpotRules")}
              element={<BadBeatJackpotRules />}
            />
            <Route path={t("routes.highHands")} element={<HighHands />} />
            <Route
              path={t("routes.worldCupOfCards2021")}
              element={<WorldCupOfCards2021 />}
            />
            <Route
              path={t("routes.highHandFebruary2025")}
              element={<HighHandFebruary2025 />}
            />
            <Route
              path={t("routes.wsopcPlaygroundSpring2025ColossusGiveawayQ")}
              element={<WsopcPlaygroundSpring2025ColossusGiveaway />}
            />
            <Route
              path={t("routes.wsopcPlaygroundSpring2025ColossusGiveawayA")}
              element={<WsopcPlaygroundSpring2025ColossusGiveaway />}
            />
            <Route
              path={t("routes.mainEventMaynia2025")}
              element={<MainEventMaynia2025 />}
            />

            {/* INDIVIDUAL TOURNAMENT CARD VIEWS (BACKWARD COMPATIBILITY) */}
            <Route path={t("routes.tournamentByGid")} element={<IndividualTournament />} />

            {/* POKER TOURNAMENT URLS WPT/WSOP */}
            <Route path="/poker/tournaments/:tournamentSlug" element={<TournamentDetails />}>
              <Route path=":tournamentTabSlug" element={<TournamentDetails />}>
                <Route path=":chipCountSlug" element={<TournamentDetails />} />
              </Route>
            </Route>
            <Route path="/fr/poker/tournois/:tournamentSlug" element={<TournamentDetails />}>
              <Route path=":tournamentTabSlug" element={<TournamentDetails />}>
                <Route path=":chipCountSlug" element={<TournamentDetails />} />
              </Route>
            </Route>

            {/* TEMP PAGE TO LIST TOURNAMENT URLS */}
            <Route
              path={t("routes.tournamentList")}
              element={<TournamentList />}
            />

            <Route
              path={t("routes.eatAndPlay")}
              element={<EatAndPlay />}
            />
            <Route
              path={t("routes.eatAndPlayTab")}
              element={<EatAndPlay />}
            />
            <Route path={t("routes.cashGames")} element={<CashGames />} />
            <Route
              path={t("routes.pastEvents")}
              element={<PastEvents />}
            />
            <Route
              path={t("routes.pastEventWinners")}
              element={<PastEventWinners />}
            />
            <Route path={t("routes.tlb")} element={<TournamentLeaderboard />} />
            <Route
              path={t("routes.monteCarloJackpots2024")}
              element={<MonterCarlo2024 />}
            />
            <Route
              path={t("routes.irishOpen2024")}
              element={<IrishOpen2024 />}
            />
            <Route
              path={t("routes.irishOpen2025")}
              element={<IrishOpen2025 />}
            />
            <Route
              path={t("routes.mysteryHighHand2024")}
              element={<MysteryHighHand />}
            />
            <Route
              path={t("routes.megaMysteryHighHand2024")}
              element={<MegaMysteryHighHand />}
            />
            <Route
              path={t("routes.mysteryHighHandOctober2024")}
              element={<MysteryHighHandOctober2024 />}
            />
            <Route
              path={t("routes.mysteryHighHandNovember2024")}
              element={<MysteryHighHandNovember2024 />}
            />
            <Route
              path={t("routes.highHandJanuary2025")}
              element={<HighHandJanuary2025 />}
            />
            <Route
              path={t("routes.chaseTheAce2024")}
              element={<ChaseTheAce2024 />}
            />
            <Route
              path={t("routes.pokerNewYearsEve2025")}
              element={<PokerNewYearsEve2025 />}
            />
            <Route
              path={t("routes.titanTuesday2025")}
              element={<TitanTuesday2025 />}
            />
            <Route
              path={t("routes.titanTuesday2026")}
              element={<TitanTuesday2026 />}
            />
            <Route
              path={t("routes.titanTuesdayMarch2026")}
              element={<TitanTuesdayMarch2026 />}
            />
            <Route
              path={t("routes.titanTuesdayMay2026")}
              element={<TitanTuesdayMay2026 />}
            />
            <Route
              path={t("routes.hockeyNightAtPlayground2025")}
              element={<HockeyNightAtPlayground2025 />}
            />
            <Route
              path={t("routes.hockeyNightPlaygroundPlayoffs2026")}
              element={<HockeyNightPlaygroundPlayoffs2026 />}
            />
            <Route
              path={t("routes.highHandMarch2025")}
              element={<HighHandMarch2025 />}
            />

            <Route path="/promotions/poker/:highHandSlug" element={<HighHandMain />}>
            </Route>
            <Route path="/fr/promotions/poker/:highHandSlug" element={<HighHandMain />}>
            </Route>

            <Route
              path={t("routes.multiMillionaireMaker2025")}
              element={<MultiMillionaireMaker2025 />}
            />
            <Route
              path={t("routes.multiMillionaireMakerAugust2025")}
              element={<MultiMillionaireMakerAugust2025 />}
            />
            <Route
              path={t("routes.multiMillionaireMakerSeptember2025")}
              element={<MultiMillionaireMakerSeptember2025 />}
            />
            <Route
              path={t("routes.tripleBarrelCashBlast2025")}
              element={<TripleBarrelCashBlast2025 />}
            />
            <Route
              path={t("routes.tripleBarrelCashBlast2025AnniversaryEdition")}
              element={<TripleBarrelCashBlast2025AnniversaryEdition />}
            />
            <Route
              path={t("routes.tripleBarrelCashBlast2026")}
              element={<TripleBarrelCashBlast2026 />}
            />
            <Route
              path={t("routes.tripleBarrelCashBlastFebruary2026")}
              element={<TripleBarrelCashBlastFebruary2026 />}
            />
            <Route
              path={t("routes.tripleBarrelCashBlastMarch2026")}
              element={<TripleBarrelCashBlastMarch2026 />}
            />
            <Route
              path={t("routes.luxonPayGiveaway2026")}
              element={<LuxonPayGiveaway2026 />}
            />
            <Route
              path={t("routes.wsopcPlaygroundMay2026CreatorChampionship")}
              element={<WsopcPlaygroundMay2026CreatorChampionship />}
            />

            <Route path={t("routes.pokerPlayer")} element={<PokerPlayer />} />
            <Route exact="true" path={t("routes.poker")} element={<Poker />} />
            {/* confirmation page */}
            <Route
              path={t("routes.successfulPayment")}
              element={<SuccessfulPayment />}
            />
            <Route
              path={t("routes.requestPasswordSuccess")}
              element={<RequestPassword />}
            />
            <Route
              path={t("routes.unsubscribed")}
              element={<Unsubscribed />}
            />
            <Route
              path={t("routes.subscription")}
              element={<Subscription />}
            />
            <Route
              path={t("routes.addExistingUserSuccess")}
              element={<ExistingUser />}
            />
            <Route
              path={t("routes.signUpExistingUser")}
              element={<SignUpExistingUser />}
            />
            <Route path={t("routes.addNewUserSuccess")} element={<NewUser />} />
            <Route
              path={t("routes.emailVerification")}
              element={<EmailConfirmation />}
            />
            <Route
              path={t("routes.resetPassword")}
              element={<ResetPassword />}
            />
            <Route
              path={t("routes.forgotPassword")}
              element={<ForgotPassword />}
            />
            {/* entertainment */}
            <Route
              path={t("routes.musicalMonday")}
              element={<MusicalMonday />}
            />
            <Route
              path={t("routes.girlsNightOut")}
              element={<GirlsNightOut />}
            />
            <Route
              path={t("routes.gameDay2024")}
              element={<GameDay2024 />}
            />
            <Route
              path={t("routes.hockeyNightAtTheRail2024")}
              element={<HockeyNightAtTheRail2024 />}
            />
            <Route
              path={t("routes.halloween2024")}
              element={<Halloween2024 />}
            />
            <Route
              path={t("routes.newYearsEve2025")}
              element={<NewYearsEve2025 />}
            />
            <Route
              path={t("routes.newYearsEve2026")}
              element={<NewYearsEve2026 />}
            />
            <Route
              path={t("routes.valentines2025")}
              element={<Valentines2025 />}
            />
            <Route
              path={t("routes.valentines2026")}
              element={<Valentines2026 />}
            />
            <Route
              path={t("routes.bigGameBash2025")}
              element={<BigGameBash2025 />}
            />
            <Route
              path={t("routes.bigGameBash2026")}
              element={<BigGameBash2026 />}
            />
            <Route
              path={t("routes.fightQuest61")}
              element={<FightQuest61 />}
            />
            <Route
              path={t("routes.nuitElite")}
              element={<NuitElite />}
            />
            <Route
              path={t("routes.clubElite2025")}
              element={<ClubElite2025 />}
            />
            <Route
              path={t("routes.tierMatch2026")}
              element={<TierMatch2026 />}
            />
            <Route
              path={t("routes.birthdayBash2025")}
              element={<BirthdayBash2025 />}
            />
            <Route
              path={t("routes.ladiesNight2025")}
              element={<LadiesNight2025 />}
            />
            <Route
              path={t("routes.hauntedCarnival2025")}
              element={<HauntedCarnival2025 />}
            />
            <Route
              path={t("routes.ultimateDad2025")}
              element={<UltimateDad2025 />}
            />
            <Route
              path={t("routes.ultimateDad2026")}
              element={<UltimateDad2026 />}
            />
            <Route
              path={t("routes.gpFreePlay2025")}
              element={<GPFreePlay2025 />}
            />
            <Route
              path={t("routes.gpFreePlay2026")}
              element={<GPFreePlay2026 />}
            />
            <Route
              path={t("routes.multiplierFridays2025")}
              element={<MultiplierFridays2025 />}
            />
            <Route
              path={t("routes.dragonAfterHours2025")}
              element={<DragonAfterHours2025 />}
            />
            <Route
              path={t("routes.dragonDiceNights")}
              element={<DragonDiceNights />}
            />
            <Route
              path={t("routes.winningWednesday")}
              element={<WinningWednesday />}
            />
            <Route
              path={t("routes.winAMillion2025")}
              element={<WinAMillion2025 />}
            />
            <Route
              path={t("routes.winAMillionTV")}
              element={<WinAMillionTV />}
            />
            <Route
              path={t("routes.freePlayPrizesMarch2026TV")}
              element={<FreePlayPrizesMarch2026TV />}
            />
            <Route
              path={t("routes.superBowlTV2026")}
              element={<SuperBowlTV2026 />}
            />
            <Route
              path={t("routes.cashnadoSpring2026TV")}
              element={<CashnadoSpring2026TV />}
            />
            <Route
              path={t("routes.cashnado2026TV")}
              element={<Cashnado2026TV />}
            />
            <Route
              path={t("routes.cashnadoAugust2026TV")}
              element={<CashnadoAugust2026TV />}
            />
            <Route
              exact="true"
              path={t("routes.scavengerHunt2025")}
              element={<ScavengerHunt2025 />}
            />
            <Route
              exact="true"
              path={t("routes.scavengerHuntDynamic2025")}
              element={<ScavengerHuntDynamic2025 />}
            />
            <Route
              exact="true"
              path={t("routes.sickPodcastFreePlay2026")}
              element={<PodcastFreePlayDynamic2026 />}
            />
            <Route
              exact="true"
              path={t("routes.driveByPodcastFreePlay2026")}
              element={<PodcastFreePlayDynamic2026 />}
            />
            <Route
              exact="true"
              path={t("routes.standingByPodcastFreePlay2026")}
              element={<PodcastFreePlayDynamic2026 />}
            />
            <Route
              exact="true"
              path={t("routes.mysteryFortune2026")}
              element={<OpenFortuneFreePlay2026 />}
            />
            <Route
              exact="true"
              path={t("routes.hundredFortune2026")}
              element={<OpenFortuneFreePlay2026 />}
            />
            {/* blog */}
            <Route exact="true" path={t("routes.blog")} element={<Blog />} />
            <Route path={t("routes.blogBbjHits")} element={<BbjHits />} />
            <Route
              path={t("routes.blogKahnawakePowWow")}
              element={<KahnawakePowWow />}
            />
            <Route
              path={t("routes.blogAugustMillionFestival")}
              element={<AugustMillionFestival />}
            />
            <Route
              path={t("routes.blogDiscoverReasonsWsop")}
              element={<DiscoverReasonsWsop />}
            />
            {/* private events */}
            <Route
              path={t("routes.roomsForRent")}
              element={<RoomsForRent />}
            />
            <Route
              path={t("routes.roomsForRentForm")}
              element={<RoomsForRentForm />}
            />
            {/* restaurants */}
            <Route path={t("routes.theRail")} element={<TheRail />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/*" element={<Page404 />} />
          </Routes>
          {!headerFooterExcludedPaths.includes(location.pathname) && !isAppWebViewFlag && <Footer />}
        </MainDiv>
      </Suspense>
    </I18nextProvider>
  );
}

const MainDiv = styled.div`
  min-height: 100vh;
  width: 100%;
  left: 0;
  right: 0;
  & > *:not(.navbar) {
    filter: ${({ blur }) => (blur ? "blur(2px) brightness(50%)" : "none")};
  }
`;

export default App;
